






import Vue from "vue";
import coreApiClient from "@/services/apis/coreApiClient";
import DataContainer from "@vuetifyx/common/DataContainer";
import userManager from "@/services/userManager";
import ganiAsiaTenantCodes from "@/constants/ganiAsiaTenantCodes";

export default Vue.extend({
  data() {
    return {
      tableOptions: {
        attrs: {
          "item-key": "_id",
          "sort-by": "disabled",
          "sort-desc": false,
        },
        content: {
          name: "Quản lý thị trường",
          urlEnabled: true,
          search: {},
          filters: {
            filters: {
              disabled: {
                type: "select",
                attrs: {
                  label: "Trạng thái",
                  items: [
                    { text: "Hoạt động", value: false },
                    { text: "Ngừng hoạt động", value: true },
                  ],
                },
                rules: {
                  equal_to: {},
                },
              },
            },
          },
          displayFields: {
            name: {
              text: "Tên",
              sortable: true,
              options: {
                to(_, item) {
                  return `/app/markets/${item._id}/`;
                },
                attrs: {
                  class: "text-no-wrap",
                },
              },
            },
            country: {
              text: "Quốc gia",
              options: {
                subProp: "country.name",
                label: true,
                sortBy: "countryId",
              },
            },
            code: {
              text: "Mã",
              sortable: true,
            },
            disabled: {
              text: "Trạng thái",
              options: {
                label(value) {
                  return (value && "Ngừng hoạt động") || "Hoạt động";
                },
                attrs(value) {
                  return {
                    color: value ? "red" : "green",
                  };
                },
              },
            },
            currency: {
              text: "Đơn vị tiền tệ",
              sortable: true,
            },
            mktDomainApplied: !ganiAsiaTenantCodes.includes(userManager.tenantCode()) && {
              text: "Áp dụng MKT Domain",
              sortable: true,
              options: {
                boolean: true,
              },
            },
            tmdt: !ganiAsiaTenantCodes.includes(userManager.tenantCode()) && {
              text: "TMDT",
              sortable: true,
              options: {
                boolean: true,
              },
            },
            rd: !ganiAsiaTenantCodes.includes(userManager.tenantCode()) && {
              text: "RD",
              sortable: true,
              options: {
                boolean: true,
              },
            },
            main: {
              text: "TT Chính",
              sortable: true,
              options: {
                boolean: true,
              },
            },
            wholesale: {
              text: "Khách sỉ",
              sortable: true,
              options: {
                boolean: true,
              },
            },
            countryCode: {
              text: "Country Code",
              sortable: true,
            },
            exchangeRate: userManager.checkRole(["kt", "qlk"]) && {
              text: "Tỷ giá",
              sortable: true,
              options: {
                filter: "number3",
              },
            },
            mktPlatforms: {
              text: "Nền tảng MKT",
              options: {
                labels(items) {
                  return items && items.map((item) => item.name);
                },
              },
            },
            createdTime: {
              text: "Ngày tạo",
              sortable: true,
              options: {
                filter: "dateTime",
              },
            },
            action: {},
          },
          topActionButtons: {
            insert: userManager.checkRole(["admin", "kt"]) && {
              target: {
                dialog: {
                  attrs: {
                    width: "800px",
                  },
                },
              },
            },
            syncOrders: userManager.checkRole(["kt"]) && {
              attrs: {
                color: "default",
                dark: false,
              },
              content: {
                text: "Đồng bộ đơn hàng",
                icon: "mdi-sync",
              },
              on: {
                async xClick({ self }) {
                  const dataTable = self.context();
                  self.loading.value = true;
                  await dataTable.execute(
                    async () => {
                      return await coreApiClient.call("app", "syncOrders");
                    },
                    undefined,
                    {
                      disableLoading: true,
                      willRefresh: true,
                    }
                  );
                  self.loading.value = false;
                },
              },
            },
          },
          template: {
            itemActionButtons: {
              edit: userManager.checkRole(["admin", "kt"]) && {
                target: {
                  dialog: {
                    ext: {
                      subTitleMaker: "name",
                    },
                    attrs: {
                      width: "800px",
                    },
                  },
                },
              },
              delete: userManager.checkRole(["admin"]) && {},
              presetExchangeRate: !ganiAsiaTenantCodes.includes(userManager.tenantCode()) &&
                userManager.checkRole(["kt"]) && {
                  attrs: {},
                  content: {
                    icon: "mdi-currency-usd",
                  },
                  target: {
                    tooltip: {
                      content: {
                        text: "Cập nhật tỷ giá",
                      },
                    },
                    dialog: {
                      handlers: {
                        initialize() {
                          this.options.content.buttons.save.states.enabled = new DataContainer(false);
                        },
                      },
                      content: {
                        toolbar: {
                          title: "Cập nhật tỉ giá",
                          subTitle(dialog) {
                            const btn = dialog.context();
                            const { item } = btn.context();
                            return item.name;
                          },
                        },
                        content: {
                          type: "XForm",
                          makeAttrs(attrs, dialog) {
                            const { item } = dialog.context().context();
                            attrs.xModel = dialog.options.content.buttons.save.states.enabled;
                            attrs.xContext = dialog;
                            attrs.xData = new DataContainer({
                              nextExchangeRate: item.nextExchangeRate,
                              nextExchangeRateStartTime: item.nextExchangeRateStartTime,
                            });
                            attrs.xOptions = {
                              content: {
                                sections: {
                                  default: {
                                    fields: {
                                      nextExchangeRate: {
                                        type: "number",
                                        attrs: {
                                          label: "Tỷ giá mới",
                                          required: true,
                                          "prepend-icon": "mdi-currency-usd",
                                          suffix: `VNĐ / ${item.currency}`,
                                          autofocus: true,
                                        },
                                      },
                                      nextExchangeRateStartTime: {
                                        type: "XDateTimePicker",
                                        attrs: {
                                          label: "Ngày chuyển tỉ giá",
                                          xOptions: {
                                            content: {
                                              resetable: true,
                                            },
                                          },
                                        },
                                      },
                                    },
                                  },
                                },
                              },
                            };
                            return attrs;
                          },
                          attrs: {},
                        },
                        buttons: {
                          save: {
                            content: {
                              text: "Cập nhật",
                            },
                            states: {},
                            on: {
                              async xClick({ self }) {
                                const dialog = self.context();
                                const btn = dialog.context();
                                const { item, dataTable } = btn.context();
                                const form = dialog.contentContainer.value;
                                const data = form.getData();
                                self.loading.value = true;
                                const result = await dataTable.execute(
                                  async () => {
                                    return await coreApiClient.call(
                                      "markets",
                                      "update",
                                      {
                                        id: item._id,
                                      },
                                      {
                                        data: {
                                          nextExchangeRate: data.nextExchangeRate,
                                          nextExchangeRateStartTime: data.nextExchangeRateStartTime,
                                        },
                                      }
                                    );
                                  },
                                  undefined,
                                  {
                                    disableLoading: true,
                                    willRefresh: true,
                                  }
                                );
                                self.loading.value = false;
                                if (result) {
                                  dialog.hide();
                                }
                              },
                            },
                          },
                        },
                      },
                    },
                  },
                },
            },
          },
          findAllOptionsFilter(options) {
            options.orderItems = [];
            const usedFields = [];
            if (options.orderBy) {
              options.orderItems.push({
                field: options.orderBy,
                type: options.orderType,
              });
              usedFields.push(options.orderBy);
              options.orderBy = undefined;
              options.orderType = undefined;
            }
            if (!usedFields.includes("disabled")) {
              options.orderItems.push({
                field: "disabled",
                type: "asc",
              });
            }
            if (!usedFields.includes("name")) {
              options.orderItems.push({
                field: "name",
                type: "asc",
              });
            }
            return options;
          },
        },
        ext: {
          dataProvider: {
            async findAll(options) {
              const { items, count } = await coreApiClient.call("markets", "findAll", options);
              return [items, count];
            },
            async insert(item) {
              return await coreApiClient.call("markets", "create", undefined, item);
            },
            async update(item) {
              return await coreApiClient.call(
                "markets",
                "update",
                {
                  id: item._id,
                },
                {
                  data: item,
                }
              );
            },
            async delete(item) {
              return await coreApiClient.call("markets", "delete", {
                id: item._id,
              });
            },
          },
          default: {
            defaultInputs: {
              name: {
                attrs: {
                  label: "Tên",
                  required: true,
                },
              },
              countryId: {
                type: "XAutocomplete",
                attrs: {
                  label: "Quốc gia",
                  required: true,
                  "item-value": "_id",
                  "item-text": "name",
                  xOptions: {
                    content: {
                      async itemsLoader() {
                        const { items } = await coreApiClient.call("countries", "findAll", {
                          limit: -1,
                        });
                        return items;
                      },
                    },
                  },
                },
              },
              code: {
                attrs: {
                  label: "Mã",
                  required: true,
                },
              },
              disabled: {
                type: "select",
                attrs: {
                  label: "Trạng thái",
                  items: [
                    { text: "Hoạt động", value: false },
                    { text: "Ngừng hoạt động", value: true },
                  ],
                },
              },
              currency: {
                attrs: {
                  label: "Đơn vị tiền tệ",
                  required: true,
                },
              },
              exchangeRate: {
                attrs: {
                  label: "Tỉ giá",
                  required: true,
                },
              },
              description: {
                type: "textLarge",
                attrs: {
                  label: "Mô tả",
                },
              },
              mktDomainApplied: {
                type: "boolean",
                attrs: {
                  label: "Áp dụng MKT Domain",
                },
                ext: {
                  condition() {
                    return !ganiAsiaTenantCodes.includes(userManager.tenantCode());
                  },
                },
              },
              tmdt: {
                type: "boolean",
                attrs: {
                  label: "TMDT",
                },
                ext: {
                  condition() {
                    return !ganiAsiaTenantCodes.includes(userManager.tenantCode());
                  },
                },
              },
              rd: {
                type: "boolean",
                attrs: {
                  label: "RD",
                },
                ext: {
                  condition() {
                    return !ganiAsiaTenantCodes.includes(userManager.tenantCode());
                  },
                },
              },
              main: {
                type: "boolean",
                attrs: {
                  label: "TT Chính",
                },
                ext: {
                  condition() {
                    return !ganiAsiaTenantCodes.includes(userManager.tenantCode());
                  },
                },
              },
              wholesale: userManager.checkRole(["kt", "vd", "vdl"]) && {
                type: "boolean",
                attrs: {
                  label: "Khách sỉ",
                },
              },
              countryCode: {
                attrs: {
                  label: "Country Code",
                },
              },
              mktPlatformIds: {
                type: "XAutocomplete",
                attrs: {
                  label: "Nền tảng MKT",
                  "item-value": "_id",
                  "item-text": "name",
                  multiple: true,
                  xOptions: {
                    content: {
                      async itemsSuggestor(search, value, limit) {
                        const { items } = await coreApiClient.call("mktPlatforms", "findAll", {
                          payload: JSON.stringify({
                            limit,
                            search,
                            filters: [
                              {
                                key: "_id",
                                operator: "in",
                                value,
                              },
                            ],
                          }),
                        });
                        return items;
                      },
                    },
                  },
                },
              },
              commissionFeePercentageItems: {
                type: "XArrayInput",
                attrs: {
                  label: "Lịch sử commission fee",
                  xOptions: {
                    content: {
                      itemProperties: {
                        time: {
                          type: "XDateTimePicker",
                          attrs: {
                            label: "Ngày bắt đầu",
                            required: true,
                          },
                        },
                        value: {
                          type: "number",
                          attrs: {
                            label: "Commission fee (%)",
                            required: true,
                          },
                        },
                        description: {
                          type: "textLarge",
                          attrs: {
                            label: "Mô tả",
                          },
                        },
                      },
                      template: {
                        formOptions: {
                          content: {
                            colLength: 4,
                          },
                        },
                      },
                    },
                  },
                },
                ext: {
                  condition() {
                    return !ganiAsiaTenantCodes.includes(userManager.tenantCode());
                  },
                },
              },
              extraFeeItems: {
                type: "XArrayInput",
                attrs: {
                  label: "Phí bổ sung",
                  xOptions: {
                    content: {
                      itemProperties: {
                        time: {
                          type: "XDateTimePicker",
                          attrs: {
                            label: "Ngày bắt đầu",
                            required: true,
                          },
                        },
                        value: {
                          type: "number",
                          attrs: {
                            label: "Giá trị",
                            required: true,
                          },
                        },
                        description: {
                          type: "textLarge",
                          attrs: {
                            label: "Mô tả",
                          },
                        },
                      },
                      template: {
                        formOptions: {
                          content: {
                            colLength: 4,
                          },
                        },
                      },
                    },
                  },
                },
                ext: {
                  condition() {
                    return !ganiAsiaTenantCodes.includes(userManager.tenantCode());
                  },
                },
              },
              feeScheduleItems: {
                type: "XArrayInput",
                attrs: {
                  label: "Biểu phí (DSDK)",
                  xOptions: {
                    content: {
                      itemProperties: {
                        name: {
                          type: "text",
                          attrs: {
                            label: "Tên phí",
                            required: true,
                          },
                        },
                        type: {
                          type: "select",
                          attrs: {
                            label: "Loại",
                            required: true,
                            items: [
                              { value: "percentage", text: "%" },
                              { value: "fixed", text: "Cố định" },
                            ],
                          },
                          ext: {
                            defaultValue: "percentage",
                          },
                        },
                        startTime: {
                          type: "XDateTimePicker",
                          attrs: {
                            label: "Ngày bắt đầu",
                            required: true,
                          },
                        },
                        endTime: {
                          type: "XDateTimePicker",
                          attrs: {
                            label: "Ngày kết thúc",
                          },
                        },
                        value: {
                          type: "number",
                          attrs: {
                            label: "Giá trị",
                            required: true,
                          },
                        },
                        description: {
                          type: "textLarge",
                          attrs: {
                            label: "Mô tả",
                          },
                        },
                      },
                      template: {
                        formOptions: {
                          content: {
                            colLength: 2,
                          },
                        },
                      },
                    },
                  },
                },
                ext: {
                  condition() {
                    return !ganiAsiaTenantCodes.includes(userManager.tenantCode());
                  },
                },
              },
            },
            insertForm: userManager.checkRole(["admin", "kt"]) && {
              content: {
                fieldNames: ["name", "countryId", "code", "disabled", "currency", "exchangeRate", "description", "mktDomainApplied", "tmdt", "rd", "main", "wholesale", "countryCode", "mktPlatformIds", "commissionFeePercentageItems", "extraFeeItems", "feeScheduleItems"],
              },
            },
            editForm: userManager.checkRole(["admin", "kt"]) && {
              content: {
                fieldNames: ["name", "countryId", "code", "disabled", "currency", "exchangeRate", "description", "mktDomainApplied", "tmdt", "rd", "main", "wholesale", "countryCode", "mktPlatformIds", "commissionFeePercentageItems", "extraFeeItems", "feeScheduleItems"],
              },
            },
            delete: userManager.checkRole(["admin"]) && {
              confirmDisplayField: "name",
            },
          },
        },
      },
    };
  },
});
